import React from 'react'
import "./Footer.css"

export default function Footer() {
  return (
    <div>
        <div className="bithu_v1_footer_sect">
  <div className="container">

    <div className="bithu_v1_footer_content">
      


      <div className="footer_social_links">
        <ul>
         
          <li className="social_hov_shape_show">
            <a href="https://x.com/bitrockwallet" target='blank'>
              <i className="fa-brands fa-twitter" />
            </a>
            <span className="social_hov_shape1">
              <img src="assets/images/hov_shape_s.svg" alt="" />
            </span>
          </li>
          <li className="social_hov_shape_show">
            <a href="https://t.me/bitrockwallet" target='blank'>
              <i className="fa-brands fa-telegram" />
            </a>
            <span className="social_hov_shape1">
              <img src="assets/images/hov_shape_s.svg" alt="" />
            </span>
          </li>
         
        </ul>
      </div>
      <div className="footer_stras_sect">
        <div className="footer_stars">
          <span className="star_1">
            <img src="assets/images/star_6.svg" alt="" />
          </span>
          <span className="star_2">
            <img src="assets/images/star_3.svg" alt="" />
          </span>
          <span className="star_3">
            <img src="assets/images/star_1.svg" alt="" />
          </span>
          <span className="star_4">
            <img src="assets/images/star_7.svg" alt="" />
          </span>
          <span className="star_5">
            <img src="assets/images/star_4.svg" alt="" />
          </span>
          <span className="star_6">
            <img src="assets/images/star_2.svg" alt="" />
          </span>
          <span className="star_7">
            <img src="assets/images/star_5.svg" alt="" />
          </span>
        </div>
      </div>
    </div>
  </div>
  <div className="bithu_v1_main_footer">
    <div className="bithu_v1_main_footer_overlay"></div>
    
    <div className="footer_bottom">
      <div className="footer_bottom_content">
        <span className="footer_shapes_left">
          <img src="assets/images/footer_shapes_left.png" alt="" />
        </span>
        <span className="footer_shapes_right">
          <img src="assets/images/footer_shapes_right.png" alt="" />
        </span>
        <div className="container">
          <div className="footer_menu">
            <div className="bottom_footer_left">
              <div className="footer_logo">
                <a href="#" className='text-white '>
                Bitrock Wallet NFT Collections
                  {/* <img src="assets/images/logo.png" alt="" /> */}
                </a>
              </div>
             
            </div>
            <a href="#" className="bact_to_top_btn">
              <img src="assets/images/back_to_top.svg" alt="" />
            </a>
            <div className="bottom_footer_right">
              <ul>
                <li>
                  <a href="#home">Home</a>
                </li>
                <li>
                  <a href="#about">About</a>
                </li>
               
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

    </div>
  )
}
